<template>



	<div style="background:var(--grey-3); ">



		<div class="center" style="">


			<hr />
			<div class="flexcenter" style="width:100%;">

				<ProductImageSquare
					filename="http://public2.boove.se.dev2/w2image/img11_66152c1588bb4242f9d6e326e16f2e8e_2_sample.jpg" />

				<ProductImageSquare
					filename="http://public2.boove.se.dev2/w2image/img11_76cece07bd6b9b63f2c334e1871c9ad0_1_samplewide.jpg" />

				<ProductImageSquare
					filename="http://public2.boove.se.dev2/w2image/img11_9937d587b5d1f11ea69dba078a83d216_0_samplehigh.jpg" />

			</div>

			<hr />

			<div id="container" class="center center-padding ">

				<div id="box1" class="box">
					<div class="boxHeader">HEADER</div>
					<ProductImageSquare
						filename="http://public2.boove.se.dev2/w2image/img11_66152c1588bb4242f9d6e326e16f2e8e_2_sample.jpg"
						style="width:calc(100% - 2px);" />
					<div class="boxContent">
						BOX1<br />BOX1<br />BOX1<br />BOX1<br />BOX1<br />BOX1<br />
					</div>
					<div class="boxPrice">
						900 kr
					</div>
					<div class="boxSpacer"></div>
					<div class="boxFooter">FOOTER</div>
				</div>
				<div id="box2" class="box" style="">
					<div class="boxHeader">HEADER</div>
					<div class="boxContent" style="">
						BOX2<br />BOX2<br />BOX2<br />BOX2<br />BOX2<br />BOX2<br />
						BOX2<br />BOX2<br />BOX2<br />BOX2<br />BOX2<br />BOX2<br />

					</div>
					<div class="boxPrice">900 kr</div>
					<div class="boxSpacer"></div>
					<div class="boxFooter">FOOTER</div>
				</div>
				<div id="box3" class="box">
					<div class="boxHeader">HEADER</div>
					<ProductImageSquare
						filename="http://public2.boove.se.dev2/w2image/img11_66152c1588bb4242f9d6e326e16f2e8e_2_sample.jpg"
						style="width:100%;" />

					<div class="boxContent">
						BOX3<br />BOX3<br />
					</div>
					<div class="boxPrice">900 kr</div>
					<div class="boxSpacer"></div>
					<div class="boxFooter">FOOTER</div>
				</div>
				<div id="box4" class="box">
					<div class="boxHeader">HEADER</div>
					<div class="boxContent">

						BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />
						BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />
						BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />
						BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />BOX4<br />
						BOX4<br />
					</div>
					<div class="boxPrice">900 kr</div>
					<div class="boxSpacer"></div>
					<div class="boxFooter">FOOTER</div>
				</div>
				<div id="box5" class="box">
					<div class="boxHeader">HEADER</div>
					<ProductImageSquare
						filename="http://public2.boove.se.dev2/w2image/img11_66152c1588bb4242f9d6e326e16f2e8e_2_sample.jpg"
						style="width:calc(100% - 2px);" />

					<div class="boxContent">
						BOX5<br />BOX5<br />
					</div>
					<div class="boxPrice">900 kr</div>
					<div class="boxSpacer"></div>
					<div class="boxFooter">FOOTER</div>
				</div>
				<div id="box6" class="box">
					<div class="boxHeader">HEADER</div>
					<ProductImageSquare
						filename="http://public2.boove.se.dev2/w2image/img11_76cece07bd6b9b63f2c334e1871c9ad0_1_samplewide.jpg"
						style="width:calc(100% - 2px);" />


					<div class="boxContent">
						BOX6<br />BOX6<br />
					</div>
					<div class="boxPrice">900 kr</div>
					<div class="boxSpacer"></div>
					<div class="boxFooter">666 kr</div>

				</div>
				<div id="box7" class="box">
					<div class="boxHeader">HEADER</div>
					<ProductImageSquare
						filename="http://public2.boove.se.dev2/w2image/img11_9937d587b5d1f11ea69dba078a83d216_0_samplehigh.jpg"
						style="width:calc(100% - 2px);" />

					<div class="boxContent">
						BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />
						BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />
						BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />BOX7<br />
					</div>
					<div class="boxPrice">900 kr</div>
					<div class="boxSpacer"></div>
					<div class="boxFooter">666 kr</div>
				</div>

				<div id="box8" class="box">
					<div class="boxHeader">HEADER</div>
					<ProductImageSquare
						filename="http://public2.boove.se.dev2/w2image/img11_76cece07bd6b9b63f2c334e1871c9ad0_1_samplewide.jpg"
						style="width:calc(100% - 2px);" />

					<div class="boxContent">
						BOX8
					</div>
					<div class="boxPrice">900 kr</div>
					<div class="boxSpacer"></div>
					<div class="boxFooter">666 kr</div>
				</div>

				<div id="box9" class="box">
					<div class="boxHeader">HEADER</div>
					<ProductImageSquare
						filename="http://public2.boove.se.dev2/w2image/img11_9937d587b5d1f11ea69dba078a83d216_0_samplehigh.jpg"
						style="width:calc(100% - 2px);" />

					<div class="boxContent">
						BOX9
					</div>
					<div class="boxPrice">900 kr</div>
					<div class="boxSpacer"></div>
					<div class="boxFooter">666 kr</div>
				</div>

				<div id="box10" class="box">
					<div class="boxHeader">HEADER</div>
					<ProductImageSquare
						filename="http://public2.boove.se.dev2/w2image/img11_9937d587b5d1f11ea69dba078a83d216_0_samplehigh.jpg"
						style="width:calc(100% - 2px);" />

					<div class="boxContent">
						BOX10<br />BOX10<br />BOX10<br />
					</div>
					<div class="boxPrice">900 kr</div>
					<div class="boxSpacer"></div>
					<div class="boxFooter">666 kr</div>
				</div>
			</div>

			<hr>

			<div class="c2">
				<div id="b1" class="b">1 </div>
				<div id="b2" class="b">2 </div>
				<div id="b3" class="b">3 </div>


				<div id="b4" class="b">4 4<br />4<br />4<br />4<br /> 4<br />4<br />4
				</div>
				<div id="b5" class="b">5 </div>
				<div id="b6" class="b">6 </div>


				<div id="b7" class="b">7<br />7<br />7<br />7<br />7<br />7<br />7<br />7<br />7<br />7<br />7<br /></div>
				<div id="b8" class="b">8</div>
				<div id="b9" class="b">9</div>

			</div>

		</div>
		<div style="height:400px;"></div>
	</div>
</template>
<script>
import ProductImageSquare from '../product/ProductCellImageSquare.vue';
export default {
	name: "TestImageCSS",
	components: { ProductImageSquare }
	
};
</script>

<style scoped>

div.c2{
	display: grid;
		column-gap: 10px;
		row-gap: 0px;
		grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
		grid-template-rows: repeat(2, auto);
		grid-auto-rows: 0px;
			position: relative;
			overflow: hidden;

}
div.b{
	background:red; 
	padding:10px;
	min-height:220px;
	overflow:hidden;
	margin-bottom:10px;
}

@media (max-width: 620px) {
	div.c2 {
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
		border: 5px solid red;
	}
}

div.imageBox{
	width: 30%;
	display: flex;
	align-items:center;
	aspect-ratio: 1;
	
}

div img{
	width:100%;
	height:100%;
	margin: 0 auto;
	object-fit: contain;
	padding:10px;
}

div.box{
	background:white; 
	min-height: 200px;
	display: flex;
	flex-direction: column;
	align-items: start;
	justify-content: start;
	padding:10px;
	border-radius: 2px;
	
}



div.boxFooter, div.boxHeader{
	display:flex;
	background:var(--grey-2);
	width:100%;
	height:30px;
	align-items: center;
	/*justify-content: center;*/
	color:lightcoral;
}

div.boxHeader{
	display: none;
}

div.boxPrice {
	
	background: lightblue;
	width:calc(100% - 10px);
	padding:5px;
	border-radius: 5px;
}

div.boxContent{
	
	overflow-y:scroll;
	max-height: 100px;
	width:100%;
	border:1px solid white;

}

div.boxSpacer{
flex-grow: 1;
background:transparent;
width:100%;
}

div#container{
display:grid;
gap:10px;
grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
grid-template-rows: repeat(minmax(200px, 300px));
}

@media (max-width: 620px) {
	div#container {
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
		border:5px solid red;
	}
}


</style>